import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'ui/i18n';

import './PageHeader.scss';

export default class PageHeader extends Component {
	static propTypes = {
		headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	};

	static defaultProps = {
		headerText: '',
	};

	render() {
		return (
			<div className="row PageHeader" id="PageHeader">
				<Link to="/" className="homeLink">
					<FormattedMessage id="navigation.home" />
				</Link>{' '}
				{` > `}
				<p className="headerText">{this.props.headerText}</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PageHeader/index.js